const getConsultationStatusByLang = (status, t) => {
    switch (status) {
        case 'Call Accepted':
            return t("Global.Consultation.Status.CallAccepted");
        case 'Offline':
            return t("Global.Consultation.Status.Offline");
        case 'Decline':
            return t("Global.Consultation.Status.Decline");
        case 'Missed':
            return t("Global.Consultation.Status.Missed");
        case 'Completed':
            return t("Global.Consultation.Status.Completed");
        case 'Disconnected':
            return t("Global.Consultation.Status.Disconnected");
        default:
            break;
    }
}

export default getConsultationStatusByLang





// WEBPACK FOOTER //
// ./src/components/common/consultationStatusByLang.js